var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAdvantage4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 49C41.2843 49 48 42.2843 48 34C48 25.7157 41.2843 19 33 19C24.7157 19 18 25.7157 18 34C18 42.2843 24.7157 49 33 49ZM33.3677 26.0583C33.3677 25.3679 32.8081 24.8083 32.1177 24.8083C31.4274 24.8083 30.8677 25.3679 30.8677 26.0583V34.8818C30.8677 35.3843 31.1685 35.8379 31.6314 36.0333L39.0137 39.1512C39.6497 39.4198 40.383 39.122 40.6516 38.486C40.9201 37.8501 40.6223 37.1168 39.9864 36.8482L33.3677 34.0528V26.0583Z",
    fill: "#FFBDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdvantage4);
export default __webpack_public_path__ + "static/media/ico_advantage4.c6c5984b65e16f73757109bf1424139b.svg";
export { ForwardRef as ReactComponent };